/* Infinite looping for the product media gallery.

   Dawn's SliderComponent carries an `enableSliderLooping` flag, but it only
   stops the arrows from being disabled at the ends -- it never wraps. This
   adds the wrap, and keeps working after Dawn re-renders the gallery on a
   variant change.

   Loaded from the 'styles' block of templates/product.v2.json. */

(function () {
  'use strict';

  var EDGE = 4; // px tolerance for "at the end"

  function sliders(root) {
    return (root || document).querySelectorAll('media-gallery slider-component');
  }

  function enableLooping(root) {
    sliders(root).forEach(function (comp) {
      if (comp.dataset.monroeLoop === 'on') return;
      comp.dataset.monroeLoop = 'on';
      comp.enableSliderLooping = true;
      comp.querySelectorAll('button[name="previous"], button[name="next"]').forEach(function (b) {
        b.removeAttribute('disabled');
      });
      if (typeof comp.update === 'function') {
        try {
          comp.update();
        } catch (e) {}
      }
    });
  }

  /* Dawn's update() re-runs on every scroll. With the flag on it skips the
     disable branch, but a button disabled before we got here stays disabled
     and then never fires a click. */
  function undisable(root) {
    sliders(root).forEach(function (comp) {
      comp.querySelectorAll('button[disabled]').forEach(function (b) {
        if (b.name === 'previous' || b.name === 'next') b.removeAttribute('disabled');
      });
    });
  }

  /* Capture on document so this runs before the button's own listener.
     stopImmediatePropagation keeps the event from ever reaching Dawn. */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('button[name="previous"], button[name="next"]');
      if (!button) return;

      var comp = button.closest('slider-component');
      if (!comp || !comp.closest('media-gallery')) return;

      var slider = comp.slider || comp.querySelector('[id^="Slider-"]');
      if (!slider) return;

      var atStart = slider.scrollLeft <= EDGE;
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - EDGE;

      if (button.name === 'next' && atEnd) {
        event.preventDefault();
        event.stopImmediatePropagation();
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (button.name === 'previous' && atStart) {
        event.preventDefault();
        event.stopImmediatePropagation();
        slider.scrollTo({ left: slider.scrollWidth, behavior: 'smooth' });
      }
    },
    true
  );

  function boot() {
    enableLooping();
    undisable();

    var host = document.getElementById('MainContent') || document.body;
    new MutationObserver(function () {
      enableLooping();
      undisable();
    }).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('slider-component').then(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
